import { DeleteForever, Edit, SchoolTwoTone } from "@mui/icons-material";
import {
  Avatar,
  Box,
  IconButton,
  ListItem,
  Paper,
  Typography,
} from "@mui/material";
import { HbType } from "../../utils/ConstType";
import Constants from "../../utils/Constants";

export default function CampusListItem({
  campusDetails: c,
  onDelete,
  onEdit,
}: {
  campusDetails: HbType.CampusDataType;
  onDelete: () => void;
  onEdit: () => void;
}) {
  return (
    <ListItem disablePadding>
      <Paper
        sx={{
          margin: 0.3,
          width: "100%",
          minWidth: 200,
          // border: "1px solid black",
          padding: "4px 8px",
          borderRadius: 2,
          backgroundColor: Constants.colors.lightTheme.palette.background.paper,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start",
          "&:hover": {
            // cursor:'pointer',
            backgroundColor: "#00000005",
          },
        }}
      >
        <Box>
          <Avatar
            sx={{
              backgroundColor:
                Constants.colors.lightTheme.palette.secondary.main,
              m: 2,
            }}
          >
            <SchoolTwoTone sx={{ fontSize: 32 }} />
          </Avatar>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Box>
            <Typography
              variant="h6"
              color={Constants.colors.lightTheme.palette.text.primary}
            >
              {c.name}
            </Typography>
            <Typography
              variant="subtitle2"
              color={Constants.colors.lightTheme.palette.secondary.main}
            >{`Admin: ${c.ca_name}`}</Typography>
            <Typography
              color={Constants.colors.lightTheme.palette.text.secondary}
              sx={{ maxLines: 2 }}
            >
              {c.description.substring(0.3)}
            </Typography>
          </Box>
          <Box>
            <IconButton
              onClick={onEdit}
              size="medium"
              sx={{
                // borderRadius: 2,
                m: 0.3,
                backgroundColor:
                  Constants.colors.lightTheme.palette.primary.main,
                color: "white",
                "&:hover": {
                  color: Constants.colors.lightTheme.palette.primary.main,
                },
              }}
            >
              <Edit />
            </IconButton>
            <IconButton
              onClick={onDelete}
              size="medium"
              sx={{
                // borderRadius: 2,
                m: 0.3,
                backgroundColor: "red",
                color: "white",
                "&:hover": {
                  color: "red",
                },
              }}
            >
              <DeleteForever />
            </IconButton>
          </Box>
        </Box>
      </Paper>
    </ListItem>
  );
}
